//* 图片资源
import websiteLogo2En from "@/assets/images/common/website-logo2-en.png";
import websiteLogoEn from "@/assets/images/common/website-logo-en.png";
import websiteLogo2 from "@/assets/images/common/website-logo2.png";
import websiteLogo from "@/assets/images/common/website-logo.png";
import rddcLogo2 from "@/assets/images/common/logo2.png";
import rddcLogo from "@/assets/images/common/logo.svg";
//* 组件属性
import type { ComponentProps, NavigationOption } from "../index";
import { useLocaleRoute } from "./utils";

export const useComposable = (define: ComponentProps) => {
    //* 插件
    const i18n = useI18n();
    const route = useRoute();

    //* 静态变量
    const vars = {
        navigations: <NavigationOption[]>[
            { name: i18n.t("Home.Name"), route: { name: "Home" } },
            { name: i18n.t("Toolbox"), route: { name: "Tool" } },
            {
                name: i18n.t("Workflow"),
                routes: [
                    { name: i18n.t("MutationAlPredictorFlow"), route: { name: "Workflow" } },
                    { name: i18n.t("GeneMutationFlow"), route: { name: "Variantseek" } },
                ],
            },
            { name: i18n.t("Layout.AboutType", { type: "RDDC" }), route: { name: "About" } },
            { name: i18n.t("ContactUS"), route: { name: "ContactUs" } },
        ],
    };

    //* 公共类名
    const classify = {
        navigation: "flex items-center whitespace-nowrap px-[20px] text-[16px] leading-[32px]",
    };

    //* 计算属性
    const computeds = {
        //* Logo
        logos: computed(() => {
            //* 数据初始化
            const result = { website: "", rddc: "" };
            //* 根据不同主题切换Logo
            if (define.dark) (result.website = websiteLogo2), (result.rddc = rddcLogo2);
            else {
                result.website = websiteLogo;
                result.rddc = rddcLogo;
            }

            //* 根据不同语言环境切换Logo
            if (i18n.locale.value == "en") {
                result.website = define.dark ? websiteLogo2En : websiteLogoEn;
            }

            return result;
        }),

        //* 路由配置
        routes: computed(() => {
            return {
                zh: useLocaleRoute(route, "zh"),
                en: useLocaleRoute(route, "en"),
            };
        }),
    };

    //* 函数
    const methods = {
        //* 跳转登录页面
        login: () => {
            window.open(
                `${useRuntimeConfig().public.SSO_APP_URL}?uid=${useRuntimeConfig().public.SSO_APP_UID}&lang=${i18n.locale.value}&redirect=${
                    location.href
                }`,
                "_self"
            );
        },
    };

    return { vars, classify, computeds, methods };
};
